/** The card interview: the questions, retries, readbacks, checks and summary, and its chips. */
export const interview = {
    "iv.start": "Let's make your card. I'll ask a few questions; answer by speaking or typing.",
    "iv.ask.trade": "What work do you do?",
    "iv.ask.area": "Which area do you work in?",
    "iv.ask.rate_month": "How much do you usually take for a month?",
    "iv.ask.rate_visit": "How much do you usually take for one visit?",
    "iv.ask.min": "What's the least you'll take? Nobody else sees this.",
    "iv.band_month": "{trade} in {city}: usually {low}–{high} a month.",
    "iv.band_visit": "{trade} in {city}: usually {low}–{high} a visit.",
    "iv.band_none": "{trade}: no usual range for this work yet.",
    "iv.legal_min": "Legal minimum for {trade}, {hours} hours a day: {min} a month.",
    "iv.band_seed": "Researched from public sources, not yet checked by a union.",
    "iv.ask.languages": "Besides {lang}, which languages do you speak?",
    "iv.ask.about": "Tell customers one line about your work, or say skip.",
    "iv.ask.ask_first": "When there are {item}, should I ask you before quoting?",
    "iv.ask.auto": "When a customer agrees inside your prices, should I sign for you?",
    "iv.again.trade": "Say the work in a few words, like cook, electrician or tailor.",
    "iv.again.area": "Say the area's name, or tap it below.",
    "iv.again.amount": "Say the amount in rupees, like eight thousand.",
    "iv.again.yes_no": "Please say yes or no.",
    "iv.again.languages": "Say a language, or say none.",
    "iv.check_amount": "Did you mean {price}?",
    "iv.got_rate": "Usual rate {price}, noted.",
    "iv.got_min": "Lowest {price}, noted. Nobody else sees it.",
    "iv.err_min": "The least can't be more than your usual {price}. Say it again.",
    "iv.err_private": "That looks like a phone number or UPI ID. Your card is public, so leave it out.",
    "iv.err_long": "Keep it to one short line.",
    "iv.summary": "Your card: {trades} in {area}, usually {rate}.",
    "iv.summary_about": 'Customers will read: "{about}"',
    "iv.summary_auto_on": "When a customer agrees inside your prices, I'll sign for you.",
    "iv.summary_auto_off": "I'll ask you before signing any deal.",
    "iv.summary_min": "Your lowest: {min}. It stays on this phone.",
    "iv.confirm": "Shall I put it on the board?",
    "iv.what_change": "What should I change?",
    "iv.published": "Done. Customers near {area} can find you now.",
    "iv.skip": "Skip",
    "iv.none": "No other language",
    "iv.later": "Later",
    "iv.resume": "Carry on making my card",
    "iv.by_voice": "Fill in by talking",
};
//# sourceMappingURL=interview.js.map